import script from "./AdminSubscribeDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSubscribeDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./AdminSubscribeDashboardView.vue?vue&type=style&index=0&id=07700d88&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07700d88"]])

export default __exports__